// extracted by mini-css-extract-plugin
export default {"root":"CommunityGuidelines-root-2ce6c8f2e8f60dee991dd06ccce1b424"};